// Apache, https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/master/design-system/checkbox/src/internal/checkbox-icon.tsx
import React, {memo, useMemo} from 'react'
import {AtlasSvgPrimitive} from './AtlasSvgPrimitive'
import type {Size} from './types'

function getIcon(isIndeterminate: boolean, isChecked: boolean) {
  if (isIndeterminate) {
    return <rect fill="inherit" x="8" y="11" width="8" height="2" rx="1" />
  }

  if (isChecked) {
    return (
      <path
        d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z"
        fill="inherit"
      />
    )
  }

  // No icon
  return null
}

export type AtlasCheckboxIconProps = {
  size: Size
  isIndeterminate: boolean
  isChecked: boolean
  testId?: string
}

export const AtlasCheckboxIcon = memo<{
  size: Size
  isIndeterminate: boolean
  isChecked: boolean
  testId?: string
}>(({size, isIndeterminate, isChecked, testId}) => {
  const icon = useMemo(() => getIcon(isIndeterminate, isChecked), [isIndeterminate, isChecked])

  return (
    <AtlasSvgPrimitive
      label=""
      size={size}
      primaryColor="var(--checkbox-background-color)"
      secondaryColor="var(--checkbox-tick-color)"
      testId={testId}
    >
      <g fillRule="evenodd">
        <rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2" />
        {icon}
      </g>
    </AtlasSvgPrimitive>
  )
})

AtlasCheckboxIcon.displayName = 'AtlasCheckboxIcon'
